import { useCallback } from 'react';
import { Redirect, useFocusEffect, useLocalSearchParams } from 'expo-router';
import { Platform } from 'react-native';
import { useAuthStore } from '@/store/auth';
import { runMobileLaunchAction } from '@/lib/mobileLaunchActions';

export default function MobileLaunchAction() {
  const { action } = useLocalSearchParams();
  const token = useAuthStore(state => state.token);
  const userId = useAuthStore(state => state.user?.id);
  // Drawer screens remain mounted. Every new widget/shortcut visit must run
  // again, including when the same launch route was used earlier in the session.
  useFocusEffect(useCallback(() => {
    if (!token || !userId) return;
    if (Platform.OS === 'ios' || Platform.OS === 'android') runMobileLaunchAction(action);
  }, [action, token, userId]));
  return token && userId ? <Redirect href="/app" /> : null;
}
